import Ribbons from './Ribbons';

export default Ribbons;